import { useState } from "react";

import type { ITextfieldProps } from "@similarweb/ui-components";

import { StyledTextfield } from "./styles";

interface Props extends ITextfieldProps {
    margin?: string;
    width?: number;
}

export const TextField = (props: Props) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <StyledTextfield
            {...props}
            onBlur={() => setIsFocused(false)}
            onFocus={() => setIsFocused(true)}
            isFocused={isFocused}
        />
    );
};
